export enum OtdrStatusEnum {
  ok = 'OK',
  ko = 'KO'
}
